import { setCatalogCatalogTypes, fetchSeasons, fetchCatalogById, saveFindProductFormState } from './actions';
import { DEFAULT_CATALOG_STRUCTURE } from './constants';

export const DEFAULT_CATALOGS_STATE = {
  data: {},
  seasons: [],
  catalogId: '',
  findProductForm: {}
};

const cleanCatalogTypes = catalog => ({
  ...catalog,
  catalogTypes: catalog.catalogTypes?.map(({ id }) => id) || []
});

const normalize = (state, catalogs) => ({
  ...state,
  catalogs
});

const catalogsReducer = (state, action) => {
  const { catalogs } = state;

  switch (action.type) {
    case fetchCatalogById.event.success: {
      const { catalog } = action.payload;

      const newData = {
        [catalog.id]: {
          ...DEFAULT_CATALOG_STRUCTURE,
          ...cleanCatalogTypes(catalog)
        }
      };

      return normalize(state, { ...catalogs, data: { ...catalogs.data, ...newData } });
    }

    case setCatalogCatalogTypes.type: {
      const { catalogId, catalogTypeIds } = action.payload;

      return normalize(state, {
        ...catalogs,
        data: {
          ...catalogs.data,
          [catalogId]: {
            ...catalogs.data[catalogId],
            catalogTypes: catalogTypeIds
          }
        }
      });
    }

    case fetchSeasons.event.success: {
      const { seasons } = action.payload;
      return normalize(state, { ...catalogs, seasons });
    }

    case saveFindProductFormState.type: {
      const formState = action.payload;

      return normalize(state, { ...catalogs, findProductForm: formState });
    }

    default:
      return state;
  }
};

export default catalogsReducer;
